import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  private readonly urlBase = '/api/';
  private readonly apiKey = "AIzaSyDirtAY6VW2rgXUp2KGsY_6wYCT96M5lYQ"

  constructor(private httpClient: HttpClient) { }


  /**
    * Abre un archivo del storage
    * @param pathFile Ruta del archivo
    * @param fileName Nombre del archivo
    */
  openFileFromStorage(pathFile: string, fileName: string): Observable<any> {
    // Creamos el body de la solicitud POST con las propiedades pathFile y filename
    const body = {
      pathFile: pathFile,
      filename: fileName
    };

    // Realizamos la solicitud POST al endpoint getFileFromStorage
    return this.httpClient.post(`${this.urlBase}main/getFileFromStorage`, body, {
      // Especificamos que la respuesta debe ser tratada como un objeto de tipo Blob
      responseType: 'blob',
      // Establecemos el encabezado Content-Type como application/json
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
  }

  /**
      * Elimina un archivo del storage
      * @param pathFile Ruta del archivo que se eliminara
      */
  removeFileFromStorage(pathFile): Observable<any> {
    // Creamos el body de la solicitud POST con las propiedades pathFile
    const body = {
      pathFile: pathFile,
    };
    // Realizamos la solicitud POST al endpoint getFileFromStorage

    return this.httpClient.post(`${this.urlBase}main/removeFileFromStorage`, body).pipe(
      catchError((error: any) => {
        throw error;
      })
    );
  }
  /**
      * Elimina la carpeta del storage
      * @param pathFile Ruta del archivo que se eliminara
      */
  removeDirectoryFromStorage(pathFile): Observable<any> {
    // Creamos el body de la solicitud POST con las propiedades pathFile
    const body = {
      pathFile: pathFile,
    };
    // Realizamos la solicitud POST al endpoint getFileFromStorage

    return this.httpClient.post(`${this.urlBase}main/removeDirectoryFromStorage`, body).pipe(
      catchError((error: any) => {
        throw error;
      })
    );
  }


}
